// Calendar.jsx
import React, { useState } from "react";
import "./Calendar.css";

const monthNames = [
  "Januar", "Februar", "März", "April", "Mai", "Juni",
  "Juli", "August", "September", "Oktober", "November", "Dezember"
];

export default function Calendar({ onSelect, onRangeSelect, selectedDate, selectedContact }) {
  const [currentDate, setCurrentDate] = useState(new Date());

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  

  const rawFirstDay = new Date(year, month, 1).getDay();
  const startOffset = (rawFirstDay + 6) % 7;

  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const prevMonthDays = new Date(year, month, 0).getDate();

  const prevMonth = () => setCurrentDate(new Date(year, month - 1, 1));
  const nextMonth = () => setCurrentDate(new Date(year, month + 1, 1));

  const generateCalendarCells = () => {
    const cells = [];
    const totalCells = 42;

    for (let i = 0; i < totalCells; i++) {
      const dayNum = i - startOffset + 1;
      let displayNum;
      let isOtherMonth = false;
      let cellDate;

      if (dayNum <= 0) {
        displayNum = prevMonthDays + dayNum;
        isOtherMonth = true;
        cellDate = new Date(year, month - 1, displayNum);
      } else if (dayNum > daysInMonth) {
        displayNum = dayNum - daysInMonth;
        isOtherMonth = true;
        cellDate = new Date(year, month + 1, displayNum);
      } else {
        displayNum = dayNum;
        cellDate = new Date(year, month, displayNum);
      }

      const isSelected =
        selectedDate &&
        new Date(selectedDate).toDateString() === cellDate.toDateString();

      const isToday = cellDate.toDateString() === new Date().toDateString();

      function formatLocalDate(date) {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, "0");
        const d = String(date.getDate()).padStart(2, "0");
        return `${y}-${m}-${d}`;
      }

      const dateStr = formatLocalDate(cellDate);
      
      // Prüfe ob der Kontakt ein Event an diesem Tag hat
      const hasEvent = selectedContact?.events?.some(e => e.day === dateStr);

      // Prüfe ob der Kontakt kontaktiert werden kann
      const cannotContact = selectedContact?.canContact === false;

      // inside the loop, when pushing the cell:
      cells.push(
        <div
          key={`${cellDate.getFullYear()}-${cellDate.getMonth()}-${cellDate.getDate()}-${i}`}
          className={[
            "mini_calendar-cell",
            isOtherMonth && "mini_other-month",
            isToday && "today",
            hasEvent && "has-event",
            cannotContact && "cannot-contact",
            cannotContact && hasEvent && "has-event-cannot-contact",
            isSelected && "selected",                     // NEU
          ].filter(Boolean).join(" ")}
          role="button"
          tabIndex={0}
          onClick={() => onSelect?.(cellDate)}
          onKeyDown={(e) => e.key === "Enter" && onSelect?.(cellDate)}
        >
          {displayNum}
        </div>
      );
    }

    return cells;
  };

  const rangeButtons = [
    { label: "5T", days: 5 },
    { label: "2W", days: 14 },
    { label: "5W", days: 35 },
    { label: "3M", days: 90 },
    { label: "6M", days: 180 },
    { label: "1J", days: 365 },
  ];

  return (
    <div className="mini_calendar-container">
      <div className="mini_calendar-header">
        <button type="button" onClick={prevMonth}>←</button>
        <span>
          {monthNames[month]} {year}
        </span>
        <button type="button" onClick={nextMonth}>→</button>
      </div>
      <div className="mini_calendar-grid">{generateCalendarCells()}</div>
      <div className="mini_calendar-range">
        {rangeButtons.map((btn) => (
          <button
            key={btn.label}
            type="button"
            onClick={() => onRangeSelect?.(btn.days)}
          >
            {btn.label}
          </button>
        ))}
      </div>
    </div>
  );
}
